module.exports = __webpack_public_path__ + "static/media/wizualizacja-37.000c4b70.png";